<template>
  <div
    class="ds-rich-text"
    v-html="computedContent"
  />
</template>

<script>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
export default {
  name: 'StatusHistoryMaintenanceItem',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedContent () {
      return documentToHtmlString(this.content?.json)
    }
  }
};
</script>
